var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamationMarkModalBackground = function SvgExclamationMarkModalBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 316,
    viewBox: "0 0 364 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_98268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30.7255 67.142C-23.312 62.8618 -13.8324 65.4019 -9.55216 72.8154L27.7101 137.355C31.9903 144.769 29.4502 154.249 22.0367 158.529L-207.632 291.128C-215.045 295.408 -224.525 292.868 -228.805 285.454L-266.067 220.914C-270.347 213.501 -267.807 204.021 -260.394 199.741L-30.7255 67.142Z",
    stroke: "#DAD8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6973,
    y: 102,
    width: 17.4206,
    height: 66.6236,
    rx: 4,
    transform: "rotate(60 44.6973 102)",
    fill: "#61D5EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_98268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 364,
    height: 316,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationMarkModalBackground);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzY0IiBoZWlnaHQ9IjMxNiIgdmlld0JveD0iMCAwIDM2NCAzMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yMDkwXzk4MjY4KSI+CjxwYXRoIGQ9Ik0tMzAuNzI1NSA2Ny4xNDJDLTIzLjMxMiA2Mi44NjE4IC0xMy44MzI0IDY1LjQwMTkgLTkuNTUyMTYgNzIuODE1NEwyNy43MTAxIDEzNy4zNTVDMzEuOTkwMyAxNDQuNzY5IDI5LjQ1MDIgMTU0LjI0OSAyMi4wMzY3IDE1OC41MjlMLTIwNy42MzIgMjkxLjEyOEMtMjE1LjA0NSAyOTUuNDA4IC0yMjQuNTI1IDI5Mi44NjggLTIyOC44MDUgMjg1LjQ1NEwtMjY2LjA2NyAyMjAuOTE0Qy0yNzAuMzQ3IDIxMy41MDEgLTI2Ny44MDcgMjA0LjAyMSAtMjYwLjM5NCAxOTkuNzQxTC0zMC43MjU1IDY3LjE0MloiIHN0cm9rZT0iI0RBRDhGRiIvPgo8cmVjdCB4PSI0NC42OTczIiB5PSIxMDIiIHdpZHRoPSIxNy40MjA2IiBoZWlnaHQ9IjY2LjYyMzYiIHJ4PSI0IiB0cmFuc2Zvcm09InJvdGF0ZSg2MCA0NC42OTczIDEwMikiIGZpbGw9IiM2MUQ1RUUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yMDkwXzk4MjY4Ij4KPHJlY3Qgd2lkdGg9IjM2NCIgaGVpZ2h0PSIzMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";